import React, { Component } from "react";
import UserImage from "./../../../assets/images/user.jpg";
import FilterActiveIcon from "./../../../icons/filteractiveicon";
import FilterIcon from "./../../../icons/filtericon";
import service from "../../../../src/services";
import Loader from "../../loader";
import moment from "moment";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";

import ReactPaginate from "react-paginate";

let genreData;
let sub;
let statusFilterList = [];
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class NewFrontierListTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activetab: 0,
      exploreNewFrontierListFlim: [],
      NewFrontierList: [],
      loaderFlag: false,
      NewFrontieroffset: 0,
      perPage: 50,
      NewFrontierCurrentPage: 0,
      statusArray: [
        { assign: "Live", list: 1, value: false },
        { assign: "Disable", list: 2, value: false },
      ],
    };
    this.apiserve = new service();
  }

  componentDidMount = () => {
    let NewFrontierCurrentPage = localStorage.getItem('NewFrontierCurrentPage')
        if(NewFrontierCurrentPage) {
        this.setState(
        {
        NewFrontieroffset: parseInt(localStorage.getItem("NewFrontieroffset")),
        perPage: parseInt(localStorage.getItem("perPage")),
        NewFrontierCurrentPage: parseInt(localStorage.getItem("NewFrontierCurrentPage")),
        },
        () =>
        this.getNewForntire(this.state.NewFrontieroffset, this.state.perPage)
    );
        }else{
            this.setState({
        NewFrontieroffset:0,
        perPage:50,
        NewFrontierCurrentPage:0
    },
    () =>
        this.getNewForntire(this.state.NewFrontieroffset, this.state.perPage))
    }
   
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "newFrontier|getList":
          this.setState({
            NewFrontierList: response.data.docs,
            exploreNewFrontierListFlim: response.data.docs,
            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
            loaderFlag: false,
          });
          break;

        default:
          break;
      }
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
    statusFilterList = [];
  };

  getNewForntire = (skip, limit) => {
    this.setState({
      loaderFlag: true
  })
    var data = {
      page: skip,
      limit: limit,
    };
    this.apiserve.sendevent("newFrontier|getList", data);
  };

  editNewFrontier = (item) => {
      this.props.NewFrontierEditData(item)
      this.props.filmEditData()
      this.props.TalkEventEditData()
      this.props.OtherEventsEditData()
      this.props.LiveSceeringEditData()
      this.props.CurrentTab(2)
      // this.props.dispatch({type: 'CurrentTab', res: 2})
      this.props.history.push({
        pathname: "/film",
        callFrom:2
      });
  };

  categoryList = (id) => {
    var filmGenre =
      this.state.NewFrontierList && this.state.NewFrontierList.category;
    var names = [];
    filmGenre.forEach((f) => {
      if (f._id === id) {
        names.push(f.name);
      }
    });

    return names.map((name) => {
      return <p>{name}</p>;
    });
  };

  accessibilityList = (id) => {
    var filmGenre =
      this.state.NewFrontierList && this.state.NewFrontierList.accessibility;
    var names = [];
    filmGenre.forEach((f) => {
      if (f._id === id) {
        names.push(f.name);
      }
    });

    return names.map((name) => {
      return <p>{name}</p>;
    });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const NewFrontieroffset = selectedPage + 1;

    // page scroll top
    var tbl = document.querySelector(".film_list_table");
    tbl.scrollTo(0, 0);

    this.setState(
      {
        NewFrontierCurrentPage: selectedPage,
        NewFrontieroffset: NewFrontieroffset,
        loaderFlag: true,
      },
      () => {
        localStorage.setItem('NewFrontierCurrentPage',this.state.NewFrontierCurrentPage)
        localStorage.setItem('NewFrontieroffset',NewFrontieroffset)
        localStorage.setItem('perPage',this.state.perPage)
        this.getNewForntire(NewFrontieroffset, this.state.perPage);
      }
    );
  };

  StatusFilter = (e, selectedInex, isClearStatusType = false) => {
    let index = selectedInex;
    let event = e && e.target && e.target.checked;
    let approvePassList = [...this.state.statusArray];
    approvePassList.forEach((key, i) => {
      if (i === index) {
        approvePassList[i].value = event;
      }
      if (isClearStatusType) {
        approvePassList[i].value = false;
        statusFilterList = [];
      }
    });
    this.setState(
      {
        ...this.state,
        statusArray: approvePassList,
        NewFrontierCurrentPage: 0,
      },
      () => {
        if (event) {
          if (index !== null) {
            statusFilterList = [
              ...statusFilterList,
              this.state.statusArray[index].list,
            ];
          }
        } else {
          if (index !== null) {
            let tempArray = statusFilterList.filter(
              (d) => d !== this.state.statusArray[index].list
            );
            statusFilterList = tempArray;
          }
        }
        this.getFilmFilter(
          this.state.NewFrontieroffset,
          this.state.perPage,
          isClearStatusType
        );
      }
    );
  };

  getFilmFilter = (skip, limit, isClearStatusType) => {
    let data = {
      page: 1,
      limit: limit,
    };

    if (!isClearStatusType && statusFilterList && statusFilterList.length) {
      data.status = statusFilterList;
    }

    this.apiserve.sendevent("newFrontier|getList", data);
  };

  getLocationslist = (locations) => {

    let emptyData = []
  
    locations.map(location => {
      emptyData.push(location.name)
    });
  
    return emptyData.join(', ')
  }

  render() {
    const { exploreNewFrontierListFlim, statusArray } = this.state;
    return (
      <>
        <div className="table_wrap film_list_table">
          <table>
            <thead>
            <tr>
              <th></th>
              <th>Category</th>
              <th>Accessibility</th>
              <th>Date-Time (MT)-Location</th>
              <th>
                <span className="disp_flex d_flex_align_center">
                  Status
                  {statusFilterList && statusFilterList.length ? (
                    <FilterActiveIcon />
                  ) : (
                    <FilterIcon />
                  )}
                </span>
                <div className="tabelData_popup">
                  <form>
                    <div className="customCheck">
                      <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                        <p
                          className="link"
                          onClick={() => this.StatusFilter(null, null, true)}
                        >
                          Clear All
                        </p>
                      </div>

                      <div className="customCheckBox">
                        {statusArray.map((item, i) => (
                          <div className="customCheckBox">
                            <input
                              type="checkbox"
                              id={"status" + item.list}
                              name={"status" + item.list}
                              value={item.list ? true : false}
                              checked={item.value ? true : false}
                              onClick={(e) => this.StatusFilter(e, i)}
                            />
                            <label htmlFor={"status" + item.list}>
                              {item.assign}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </form>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            {exploreNewFrontierListFlim &&
              exploreNewFrontierListFlim.length > 0 &&
              exploreNewFrontierListFlim.map((item) => (
                <tr onClick={() => this.editNewFrontier(item._id)} className={`pointer ${item.status === 2 ? 'disable': ''}`}>
                  <td style={{width:"325px"}}>
                    <div className="disp_flex">
                      <div className="film_banner">
                        <img src={ 
                             item.images.inSite ? this.apiserve.imageUrl + item.images.inSite :
                             item.images.link ? item.images.link :
                                  '/images/image-placeholder.png'} 
                        />
                      </div>
                      <div className="film_desc">
                        <h3>{item.title}</h3>
                        <div className="disp_flex d_flex_align_center">
                          <span>{item.runTime}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{width:"400px"}}>
                    <div>
                      <p>
                        {item && item.category && item.category.displayName}
                      </p>
                    </div>
                  </td>
                  <td style={{width:"400px"}}>
                    <div>
                      {item.accessibility &&
                        item.accessibility.map((e) => {
                          return <p>{e.name}</p>;
                        })}
                    </div>
                  </td>
                  <td style={{width:"800px"}}>
                    <div>
                    {item.dateTime.sort((a, b) => a.date > b.date ? 1 : -1).map((date) => {
                        // moment(newFrontierDate).format('MMM DD')} -  {moment(newFrontierDate).format("h:mm A")
                        return(
                          date.date !== undefined && 
                          <>
                            <p>{moment(date.date).tz("US/Mountain").format('MMM DD - h:mm A')} - {moment(date.endDate).tz("US/Mountain").format('MMM DD - h:mm A')} {date.locationType === undefined || date.locationType === "2" ? '- Online' : date.locations.length > 0 ? ' - ' + this.getLocationslist(date.locations) : ''}</p>
                          </>
                        )
                        
                    })}
                    </div>
                  </td>
                  <td style={{width:"200px"}}>
                    <div>
                      <p>
                        {item.status === 1
                          ? "Live"
                          : item.status === 2
                          ? "Disabled"
                          : ""}
                      </p>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Loader */}
          {this.state.loaderFlag ? <Loader /> : ""}
        </div>
        {/* ReactPaginate  */}
        {exploreNewFrontierListFlim &&
        exploreNewFrontierListFlim.length &&
        exploreNewFrontierListFlim ? (
          <div className="custom-pagination">
            <ReactPaginate
              previousLabel={""}
              nextLabel={""}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              forcePage={this.state.NewFrontierCurrentPage}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewFrontierListTable);